import React from 'react';

const SUPPORT_EMAIL = 'support@creativex.com';

function SupportLink() {
  return <a href={`mailto: ${SUPPORT_EMAIL}`}>{ SUPPORT_EMAIL }</a>;
}

export default SupportLink;
